import { defineStore } from "pinia";
import { FetchService } from "@/services/fetch.service";
import type { GetSchedule } from "@/api_types/teacher";
import { useAuthenticationStore } from "../authentication";
import type { Dayjs } from "dayjs";

export const useAgendaStore = defineStore("teacher/agenda", {
  state: () => {
    return {
      agenda: [] as GetSchedule[],
      error: null as null | string,
      loading: true,
      team_id: 0
    };
  },
  getters: {
    getMeetingIndexById: (state) => {
      return (pta_id) => state.agenda.findIndex((meeting) => meeting.pta_id === pta_id);
    }
  },
  actions: {
    async loadAgenda(conferenceDayId) {
      this.loading = true;
      FetchService.fetchData("/schedule?conference_days_id=" + conferenceDayId, "get").then(
        (agenda) => {
          this.loading = false;
          this.agenda = agenda;
        }
      );
    },
    async reserveMeeting(
      children_uid,
      parent_uid,
      conference_id,
      conferenceDayUid,
      timeslot: Dayjs
    ) {
      const authStore = useAuthenticationStore();

      const appointment = {
        school_id: authStore.me.school_id,
        children_uid,
        parent_uid,
        team_uid: this.team_id || null,
        timeslot: timeslot.format("YYYY-MM-DD HH:mm:ss"),
        conference_id,
        conference_days_id: conferenceDayUid
      };
      const resp = await FetchService.fetchData("/schedule", "post", { appointment });
      return resp;
    },
    async cancelMeeting(ptaId) {
      return FetchService.fetchData("/schedule/" + ptaId, "delete");
    },
    async getEmail(conferenceId?) {
      let url = "/schedule/email";
      if (conferenceId) {
        url += "?conference_id=" + conferenceId;
      }
      const resp = FetchService.fetchData(url, "get");
      return resp;
    },
    async exportCalendar() {
      const resp = FetchService.fetchData("/schedule/export", "get");
      return resp;
    }
  }
});
